import React, { useState, useEffect } from 'react';
import { api } from '../services/api';
import LoadingSpinner from '../components/LoadingSpinner';
import { Building2, MapPin, User, Home } from 'lucide-react';

const labelsTipoAcesso = {
  administrador: 'Administrador',
  sindico: 'Síndico',
  subsindico: 'Subsíndico',
  porteiro: 'Porteiro',
  morador: 'Morador',
  funcionario: 'Funcionário',
  juridico: 'Jurídico',
  financeiro: 'Financeiro',
  usuario: 'Usuário'
};

/**
 * Tela para visualizar os condomínios aos quais o usuário logado está vinculado.
 */
const MeusCondominios = () => {
  const [loading, setLoading] = useState(true);
  const [lista, setLista] = useState([]);
  const [erro, setErro] = useState('');

  useEffect(() => {
    setLoading(true);
    setErro('');
    api
      .get('/usuarios/meus-condominios')
      .then((res) => {
        const condominios = res.data?.data?.condominios || res.data?.condominios || [];
        setLista(Array.isArray(condominios) ? condominios : []);
      })
      .catch((err) => {
        setErro(err.response?.data?.message || 'Erro ao carregar seus condomínios.');
        setLista([]);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingSpinner />;

  return (
    <div className="p-6">
      <div className="flex items-center gap-3 mb-6">
        <Building2 className="h-8 w-8 text-primary-600" />
        <h1 className="text-2xl font-bold text-gray-900">Condomínios que faço parte</h1>
      </div>

      {erro && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-800 mb-4">
          {erro}
        </div>
      )}

      {!erro && lista.length === 0 && (
        <div className="bg-gray-50 rounded-lg p-8 text-center text-gray-600">
          <Building2 className="h-12 w-12 mx-auto text-gray-400 mb-3" />
          <p>Você ainda não está vinculado a nenhum condomínio.</p>
          <p className="text-sm mt-1">Entre em contato com a administração para solicitar vínculo.</p>
        </div>
      )}

      {!erro && lista.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {lista.map((item) => (
            <div
              key={item.usuario_condominio_id || item.condominio_id}
              className="bg-white rounded-lg border border-gray-200 shadow-sm p-5 hover:shadow-md transition-shadow"
            >
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                  <Building2 className="h-5 w-5 text-primary-600" />
                </div>
                <div className="min-w-0 flex-1">
                  <h2 className="font-semibold text-gray-900 truncate">{item.condominio_nome}</h2>
                  {(item.condominio_cidade || item.condominio_estado) && (
                    <div className="flex items-center gap-1 text-sm text-gray-500 mt-1">
                      <MapPin className="h-4 w-4 flex-shrink-0" />
                      <span>
                        {[item.condominio_cidade, item.condominio_estado].filter(Boolean).join(' - ')}
                      </span>
                    </div>
                  )}
                  <div className="flex items-center gap-2 mt-2">
                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-primary-100 text-primary-800">
                      <User className="h-3.5 w-3.5" />
                      {labelsTipoAcesso[item.tipo_acesso] || item.tipo_acesso}
                    </span>
                    {item.apartamento && (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-700">
                        <Home className="h-3.5 w-3.5" />
                        {item.apartamento}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MeusCondominios;
